import request from '@core/services/request';

export const creditReportAPI = {
	getByCustomerId: (customerId: any, dealId: any = null, creditReportId: any = null) => {
		return request.get(`/CreditReport`, {
			params: {
				customerId,
				dealId,
				creditReportId,
			},
		});
	},
	updateRedFlags: (flagsList: any, customerId: any) => request.post(`/CreditReport/UpdateRedflag?customerId=${customerId}`, flagsList),
	assciateWithDeal: (dealId: any, creditReportId: any) =>
		request.get(`/CreditReport/AssociateWithDeal`, {
			params: {
				dealId,
				creditReportId,
			},
		}),
	copyAndAssociateCreditReport: (dealId: any, creditReportId: any) =>
		request.get(`/CreditReport/CopyAndAssociateCreditReport`, {
			params: {
				dealId,
				creditReportId,
			},
		}),
};
